import { render, staticRenderFns } from "./SocialConnectionButtons.vue?vue&type=template&id=06c133bd&scoped=true&"
import script from "./SocialConnectionButtons.vue?vue&type=script&lang=js&"
export * from "./SocialConnectionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c133bd",
  null
  
)

export default component.exports